<template>
<div class="card" v-loading.fullscreen.lock="loader">
  <div class="section-heading" align="center">CURRENT USERS</div>
  <br>
  <el-form ref="form" :model="form" :rules="rules" label-width="140px" label-position="left">
    <el-row>
      <el-col>
        <el-form-item class="col-md-12" label="Campus Name" prop="role">
          <el-select v-model="form.role" placeholder="Select Campus Name">
            <el-option
              v-for="(item, key) in surveyRolesList"
              :key="key"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <br>
  <user-list-table v-if="form.role" :tableData1="tableData"></user-list-table>
</div>
</template>
<script>
import UserListTable from './UserListTable'
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    UserListTable
  },
  data () {
    return {
      loader: false,
      surveyRolesList: [],
      welcomeMailUsers: [],
      tableData: [],
      form: {
        role: ''
      },
      rules: {
        role: [
          { required: true, message: 'Enter Question', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    ...mapActions({
      fetchSurveyRoles: 'Survey/fetchSurveyRoles',
      fetchWelcomeMailUsers: 'Survey/fetchWelcomeMailUsers'
    }),
    getTableData () {
      var tempData = []
      var arr = Object.keys(this.welcomeMailUsers.data)
      console.log('Welcome user===', this.welcomeMailUsers)
      arr.forEach((ele) => {
        console.log('ELE====', ele)
        var data = {}
        console.log('this.welcomeMailUsers.data[ele].firstName', this.welcomeMailUsers.data[ele].firstName)
        data['first_name'] = this.welcomeMailUsers.data[ele]['firstName']
        this.welcomeMailUsers.data[ele].lastName === '' ? data['last_name'] = '-' : data['last_name'] = this.welcomeMailUsers.data[ele].lastName
        data['email'] = this.welcomeMailUsers.data[ele].email
        this.welcomeMailUsers.data[ele].isActive === true ? data['status'] = 'Active' : data['status'] = 'Passive'
        data['id'] = ele
        tempData.push(data)
        // console.log('Data====', data)
      })
      this.tableData = tempData
    }
  },
  computed: {
    ...mapGetters({
      getSurveyRoles: 'Survey/getSurveyRoles',
      getWelcomeMailUsers: 'Survey/getWelcomeMailUsers'
    })
  },
  mounted () {
    this.fetchSurveyRoles()
    this.loader = true
  },
  watch: {
    getSurveyRoles (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        var arr = Object.keys(value.data)
        console.log('arrrrr', arr)
        arr.forEach(ele => {
          this.surveyRolesList.push(ele)
        })
        console.log('Survey', this.surveyRolesList)
        console.log('Roles get fetched')
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    },
    'form.role' (value) {
      console.log('Form value gets change', value)
      this.loader = true
      this.fetchWelcomeMailUsers({
        role: value
      })
    },
    tableData (value) {
      console.log('table data', value)
    },
    getWelcomeMailUsers (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.welcomeMailUsers = value
        this.getTableData()
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/User/UserList.vue